
export const baseApiUrl = 'https://pethoo.intelite.com.br/api/'
// export const baseApiUrl = 'http://localhost/:3002/api/'
export const userKey = '__orale_user'

export const operadora = {
    nome: "Pethoo",
    nomeMaiusculo: "PETHOO",
    corPrincipal: "#7e2985",
    corSecundaria: "#ffffff",
    numeroAns: 532567,
    usaCupomDesconto: true,
    usaPagamentoMensalBoleto: true,
    usaPagamentoMensalCartao: true,
    usaPagamentoAnualBoleto: true,
    usaPagamentoAnualCartao: false,
    usaPagamentoAnualParcelado: true,
}

export const modelBoleto = {
    pagadorDocumentoTipo: 1,
    pagadorDocumentoNumero: '',
    pagadorNome: '',
    pagadorEndereco: '',
    pagadorBairro: '',
    pagadorCidade: '',
    pagadorUf: '',
    pagadorCep: '',
    dataVencimento: '',
    valorNominal: 0,
    multaPercentual: 0,
    multaQuantidadeDias: 0,
    jurosPercentual: 0,
    tipoDesconto: 0,
    descontoValor: 0,
    descontoDataLimite: '',
    valorAbatimento: 0,
    tipoProtesto: 0,
    protestoQuantidadeDias: 0,
    baixaQuantidadeDias: 0,
    mensagem: '',
    tipoTitulo: 4,
    nsu: '',
    nossoNumero: 0,
    seuNumero: '',
    convenioId: '8c57439c-2dd8-4776-aa7e-5c8bff329075'
}

export default { baseApiUrl, modelBoleto, operadora }